exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".title__CardInfo-module___1_QMf {\n    text-align: left;\n    margin: 8px 0;\n    font-size: 30px;\n}\n\n.address__CardInfo-module___3JJ7G {\n    font-size: 16px;\n\n    margin-bottom: 8px;\n\n}", ""]);

// Exports
exports.locals = {
	"title": "title__CardInfo-module___1_QMf",
	"address": "address__CardInfo-module___3JJ7G"
};